import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  userMessagesData: any;
  userMessagesLoading: boolean;
  userMessagesError: SerializedError | null;
} = {
  userMessagesData: null,
  userMessagesLoading: false,
  userMessagesError: null,
};

export const userMessagesFunc = createAsyncThunk(
  'userMessages/userMessagesFunc',
  async (values: { receiverId: null | string; activityId: null | string }) => {
    const accessTokenJSON = localStorage.getItem('auth');
    const data1 = JSON.stringify({
      query: `query User_messages($receiverId: String!, $activityId: String!) {
      user_messages(receiverId: $receiverId, activityId: $activityId) {
        data {
          _id
          content
          receiver {
            _id
            description
            displayImageUrl
            displayName
            role
          }
          sender {
            _id
            description
            displayImageUrl
            displayName
            role
          }
        }
      }
    }`,
      variables: {
        activityId: values.activityId,
        receiverId: values.receiverId,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const userMessages = createSlice({
  name: 'userMessages',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userMessagesFunc.pending, (state) => {
      state.userMessagesLoading = true;
    });
    builder.addCase(userMessagesFunc.fulfilled, (state, action) => {
      state.userMessagesLoading = false;
      state.userMessagesData = action.payload.data.user_messages.data;
      state.userMessagesError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(userMessagesFunc.rejected, (state, action) => {
      state.userMessagesLoading = false;
      state.userMessagesError = action.error ?? null;
    });
  },
});

export default userMessages.reducer;
